let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9gJO7"), load("tLGOl")]).then(() => parcelRequire('anKEx'));